module.exports = __webpack_public_path__ + "static/media/A4DA0E34-1DC6-4EEA-830B-44485C0BCE03.4540c4f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/A4DA0E34-1DC6-4EEA-830B-44485C0BCE03.jpg
// module id = 308
// module chunks = 0